import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getCredits } from "../redux/features/customer/customerActions";

export function useCustomerCredits(customerInfo, userType) {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token"));
    if (!token || !customerInfo) return;

    // Fetch the wallet balance ONCE on load. We deliberately don't poll: the
    // previous version ran a 3s interval for 30s, hammering /credits ~10x on
    // every homepage visit. The balance only changes on a transaction, and
    // those paths already call refreshCustomerCredits(dispatch) at the exact
    // point credits change — so continuous polling was redundant.
    dispatch(getCredits({}));
  }, [customerInfo?.id, userType]);
}
